import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import config from "../config";
import AdminShell, { dt } from "./AdminShell";

const API = config.API_BASE_URL;

export default function AdminLeads() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [days, setDays] = useState(90);
  const [source, setSource] = useState("");

  const load = useCallback(() => {
    const params = { days };
    if (source) params.source = source;
    axios.get(`${API}/admin/leads`, { params }).then((r) => setData(r.data)).catch(() => {});
  }, [days, source]);
  useEffect(() => { load(); }, [load]);

  return (
    <AdminShell>
      <div className="ad-toolbar">
        {[30, 90, 365].map((d) => (
          <button key={d} className={`ad-btn ${days === d ? "primary" : ""}`} onClick={() => setDays(d)}>
            {d} {t("days")}
          </button>
        ))}
        <select className="ad-btn" value={source} onChange={(e) => setSource(e.target.value)}>
          <option value="">{t("All sources")}</option>
          <option value="landing">{t("Landing")}</option>
          <option value="in-app">{t("In-app")}</option>
        </select>
        {data && (
          <span className="ad-hint">{data.total} {t("leads")}</span>
        )}
      </div>

      {!data ? (
        <div className="ad-empty">…</div>
      ) : data.leads.length === 0 ? (
        <div className="ad-empty">{t("No leads in this period.")}</div>
      ) : (
        <div className="ad-table-scroll">
          <table className="ad-table">
            <thead>
              <tr>
                <th>{t("Date")}</th>
                <th>{t("Name")}</th>
                <th>{t("Phone")}</th>
                <th>Email</th>
                <th>{t("Source")}</th>
                <th>{t("Customer")}</th>
                <th>{t("Message")}</th>
              </tr>
            </thead>
            <tbody>
              {data.leads.map((l) => (
                <tr key={l.id}>
                  <td>{dt(l.created_at)}</td>
                  <td><strong>{l.name}</strong></td>
                  <td>{l.phone ? <a href={`tel:${l.phone}`}>{l.phone}</a> : "—"}</td>
                  <td>{l.email ? <a href={`mailto:${l.email}`}>{l.email}</a> : "—"}</td>
                  <td><span className={`ad-chip ${l.source === "landing" ? "ok" : ""}`}>{l.source === "landing" ? t("Landing") : t("In-app")}</span></td>
                  <td className="ad-hint">{l.companyName || "—"}</td>
                  <td className="ad-hint">{l.message || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminShell>
  );
}
